export enum GroupEventType {
	GROUP = 'HEALTHCARE',
	EVENT = 'EVENT',
}

export enum VisibilityOption {
	PUBLIC = 'public',
	ALL_TIMEDRIGHT_USERS = 'all_timedright_users',
	USERS_WITH_ACCESS = 'users_with_access',
	MEMBERS_ONLY = 'members_only',
}
